import { ActionTypes, ReduxAction } from './types';
import { Adresse, AdresseService } from '../../api';
import { Dispatch } from 'redux';
import { History } from 'history';
import { setNotification } from '../../utils/notificationUtils';
import { INFO } from '../../layouts/notification/Notification';

export const getAdresseById =
  (id: number) => async (dispatch: Dispatch<ReduxAction>) => {
    new AdresseService().getAdresseById(id).then(response => {
      dispatch({
        type: ActionTypes.GET_ADRESSE_BY_ID,
        payload: response.data,
      });
    });
  };

export const setAdresseId =
  (id: number | undefined) => (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_ADRESSE_ID,
      payload: id,
    });
  };

export const setAdresseField =
  (value: string, fieldName: string) => (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_ADRESSE_FIELD,
      payload: { value: value, fieldName: fieldName },
    });
  };

export const resetAdresserfassung =
  () => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.RESET_ADRESSERFASSUNG,
    });
    dispatch({
      type: ActionTypes.REMOVE_NOTIFICATIONS,
    });
  };

export const createAdresse =
  (
    adresse: any,
    copyid?: number | undefined,
    history?: History,
    onSuccessHandler?: () => void
  ) =>
  async (dispatch: Dispatch<ReduxAction>) => {
    new AdresseService().createAdresse(adresse).then(response => {
      dispatch({
        type: ActionTypes.SAVE_ADRESSE,
        payload: response.data,
      });
      onSuccessHandler && onSuccessHandler();
      setNotification(
        'Die Adresse ' + response.data.name + ' wurde erfolgreich gespeichert.',
        [],
        INFO,
        10000
      );
      if (copyid) {
        dispatch({
          type: ActionTypes.SET_ACTIVE_TAB,
          payload: 'adressmanagement',
        });
        history && history.push('/masterdata/adressmanagement');
      }

      dispatch({
        type: ActionTypes.SWITCH_TO_SEARCH,
        payload: { neueAdresse: response.data, adresseTyp: adresse.typ },
      });

      dispatch({
        type: ActionTypes.SET_NOTIFICATION_FIELD,
        payload: { value: undefined, fieldName: 'activeComponent' },
      });

      dispatch({
        type: ActionTypes.RESET_ADRESSERFASSUNG,
      });
    });
  };

export const updateAdresse =
  (id: number, adresse: Adresse, history: History) =>
  async (dispatch: Dispatch<ReduxAction>) => {
    new AdresseService().update(id, adresse).then(response => {
      dispatch({
        type: ActionTypes.SAVE_ADRESSE,
        payload: response.data,
      });
      setNotification(
        'Die Adresse ' +
          response.data.name +
          ' wurde erfolgreich aktualisiert.',
        [],
        INFO,
        10000
      );
      dispatch({
        type: ActionTypes.SET_ACTIVE_TAB,
        payload: 'adressmanagement',
      });
      history.push('/masterdata/adressmanagement');
      dispatch({
        type: ActionTypes.RESET_ADRESSERFASSUNG,
      });
    });
  };

export const getAdresseCopyByAdresseId =
  (id: number) => async (dispatch: Dispatch<ReduxAction>) => {
    new AdresseService().getAdresseById(id).then(response => {
      dispatch({
        type: ActionTypes.COPY_ADRESSE,
        payload: response.data,
      });
    });
  };

export const setAdresseKopieId =
  (id: number) => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_ADRESSE_KOPIE_ID,
      payload: id,
    });
  };
